import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";

import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectCreationButton({ zone }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { pushView } = useModal();

  return (
    <button
      onClick={() =>
        planzone.uuid === "57ec7e80-dcbb-49af-b11f-665fa6e545c1"
          ? pushView({
              key: UseCases.useProjectModel,
              data: { zone },
            })
          : pushView({ key: UseCases.createProject, data: { zone } })
      }
      className={styles.projectCreationButton}
    >
      <div className={styles.iconBox}>+</div>
      <p>{t("zonesPage.addProject")}</p>
    </button>
  );
}

export { ProjectCreationButton };
